// ShareModal.js
import React from "react";
import { FaWhatsapp, FaFacebook, FaTwitter, FaEnvelope, FaLink } from "react-icons/fa";
import { toast } from "react-toastify";
export default function ShareModal({ isOpen, onClose, shareUrl ,post}) {
  if (!isOpen) return null;

    const shareText = post?.share_text || shareUrl;
 
   const handleCopy = () => {
    navigator.clipboard.writeText(shareText);
    toast.success("Copied to clipboard!");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-50 flex justify-center items-end md:items-center p-4">
      <div className="bg-white w-full max-w-md rounded-t-2xl md:rounded-2xl p-6 shadow-lg relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-black text-xl font-bold"
        >
          ✕
        </button>
  <h2 className="text-xl font-bold mb-4">Share Post</h2>
        {/* --- Post Preview --- */}
        {post && (
          <div className="mb-4 border rounded-lg overflow-hidden flex">
            {post.media_url && post.media_url.length > 0 && (
              <img
                src={post.media_url[0].url}
                alt="Post Thumbnail"
                className="w-24 h-24 object-cover"
              />
            )}
            <div className="flex-1 p-2">
              <h3 className="font-semibold text-lg">{post.title || post.user?.username}</h3>
              <p className="text-gray-600 text-sm line-clamp-2">{post.content}</p>
            </div>
          </div>
        )}
   {/* --- Share Link --- */}
        <div className="flex items-center border rounded px-2 py-1 mb-4">
          <input
            type="text"
            value={shareText}
            readOnly
            className="flex-1 min-w-0 outline-none"
          />
          <button
            className="ml-2 px-3 py-1 bg-green-700 text-white rounded"
            onClick={handleCopy}
          >
            Copy
          </button>
        </div>
        <h2 className="text-lg font-semibold mb-4 text-center">Share to</h2>

        <div className="grid grid-cols-3 gap-4 text-center">
          <a
            href={`https://wa.me/?text=${encodeURIComponent(shareUrl)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-green-600"
          >
            <FaWhatsapp size={28} className="mx-auto" />
            <span className="text-sm">WhatsApp</span>
          </a>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600"
          >
            <FaFacebook size={28} className="mx-auto" />
            <span className="text-sm">Facebook</span>
          </a>
          <a
            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400"
          >
            <FaTwitter size={28} className="mx-auto" />
            <span className="text-sm">Twitter</span>
          </a>
          <a
            href={`mailto:?subject=Check this out&body=${encodeURIComponent(shareUrl)}`}
            className="text-gray-600"
          >
            <FaEnvelope size={28} className="mx-auto" />
            <span className="text-sm">Email</span>
          </a>
          <button onClick={handleCopy} className="text-gray-800">
            <FaLink size={28} className="mx-auto" />
            <span className="text-sm">Copy Link</span>
          </button>
        </div>
      </div>
    </div>
  );
}
